"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicalFamilyHistory = void 0;
class MedicalFamilyHistory {
    constructor(props) {
        this.patient = props?.patient;
        this.relationship = props?.relationship;
        this.status = props?.status;
        this.latest_update = props?.latest_update;
        this.event_sources = props?.event_sources;
        this.dt_created = props?.dt_created;
        this.dt_expired = props?.dt_expired;
    }
}
exports.MedicalFamilyHistory = MedicalFamilyHistory;
